// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)
import ApexChartController from "./apex_chart_controller"
application.register("apex-chart", ApexChartController)
import DonutChartController from "./donut_chart_controller"
application.register("donut-chart", DonutChartController)
import CompetitorAnalysisController from "./competitor_analysis_controller"
application.register("competitor-analysis", CompetitorAnalysisController)
import DateRangeCalendarController from "./date_range_calendar_controller"
application.register("date-range-calendar", DateRangeCalendarController)
import NetworkGraphController from "./network_graph_controller"
application.register("network-graph", NetworkGraphController)
import SearchController from "./search_controller"
application.register("search", SearchController)
import AcquisitionSourceController from "./acquisition_source_controller"
application.register("acquisition-source", AcquisitionSourceController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)
import AnalysisScopeController from "./analysis_scope_controller"
application.register("analysis-scope", AnalysisScopeController)
import AnalysisFilterController from "./analysis_filter_controller"
application.register("analysis-filter", AnalysisFilterController)
import SentimentMemoController from "./sentiment_memo_controller"
application.register("sentiment-memo", SentimentMemoController)
import SentimentMemoModalController from "./sentiment_memo_modal_controller"
application.register("sentiment-memo-modal", SentimentMemoModalController)
import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
import TableRowLinkController from "./table_row_link_controller"
application.register("table-row-link", TableRowLinkController)
import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)
import InstagramEmbedController from "./instagram_embed_controller"
application.register("instagram-embed", InstagramEmbedController)
import FollowersAnnotationController from "./followers_annotation_controller"
application.register("followers-annotation", FollowersAnnotationController)
import DemographicsBatchController from "./demographics_batch_controller"
application.register("demographics-batch", DemographicsBatchController)
import TwFollowersAnnotationController from "./tw_followers_annotation_controller"
application.register("tw-followers-annotation", TwFollowersAnnotationController)
import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)
import MarqueeController from "./marquee_controller"
application.register("marquee", MarqueeController)
import PostSearchController from "./post_search_controller"
application.register("post-search", PostSearchController)
import TiktokCommentsController from "./tiktok_comments_controller"
application.register("tiktok-comments", TiktokCommentsController)
import CsvExportModalController from "./csv_export_modal_controller"
application.register("csv-export-modal", CsvExportModalController)
import AiReportModalController from "./ai_report_modal_controller"
application.register("ai-report-modal", AiReportModalController)
import ModalController from "./modal_controller"
application.register("modal", ModalController)
import RecaptchaV2Controller from "./recaptcha_v2_controller"
application.register("recaptcha-v2", RecaptchaV2Controller)
import ScheduledPostController from "./scheduled_post_controller"
application.register("scheduled-post", ScheduledPostController)
import ScheduledPostPreviewController from "./scheduled_post_preview_controller"
application.register("scheduled-post-preview", ScheduledPostPreviewController)
import IgCoverFrameController from "./ig_cover_frame_controller"
application.register("ig-cover-frame", IgCoverFrameController)
import IgCollaboratorsController from "./ig_collaborators_controller"
application.register("ig-collaborators", IgCollaboratorsController)
import IgMusicController from "./ig_music_controller"
application.register("ig-music", IgMusicController)
import IgMusicPickerController from "./ig_music_picker_controller"
application.register("ig-music-picker", IgMusicPickerController)
import CategorySortableController from "./category_sortable_controller"
application.register("category-sortable", CategorySortableController)
import CategoryModalController from "./category_modal_controller"
application.register("category-modal", CategoryModalController)
import ThreadsPostFormController from "./threads_post_form_controller"
application.register("threads-post-form", ThreadsPostFormController)
import KeywordComparisonController from "./keyword_comparison_controller"
application.register("keyword-comparison", KeywordComparisonController)
import XPostFormController from "./x_post_form_controller"
application.register("x-post-form", XPostFormController)
import XPostPreviewController from "./x_post_preview_controller"
application.register("x-post-preview", XPostPreviewController)
import TiktokVideoPlayerController from "./tiktok_video_player_controller"
application.register("tiktok-video-player", TiktokVideoPlayerController)
import CaptionGenerationController from "./caption_generation_controller"
application.register("caption-generation", CaptionGenerationController)
import FramePollController from "./frame_poll_controller"
application.register("frame-poll", FramePollController)
import AggregationPollController from "./aggregation_poll_controller"
application.register("aggregation-poll", AggregationPollController)
import UrlListController from "./url_list_controller"
application.register("url-list", UrlListController)
import TiktokScheduledPostController from "./tiktok_scheduled_post_controller"
application.register("tiktok-scheduled-post", TiktokScheduledPostController)
import ToastNoticeController from "./toast_notice_controller"
application.register("toast-notice", ToastNoticeController)
import AutosaveRowController from "./autosave_row_controller"
application.register("autosave-row", AutosaveRowController)
import FadeOutController from "./fade_out_controller"
application.register("fade-out", FadeOutController)
import DomainAutofillController from "./domain_autofill_controller"
application.register("domain-autofill", DomainAutofillController)
import LpCatalogFilterController from "./lp_catalog_filter_controller"
application.register("lp-catalog-filter", LpCatalogFilterController)
import RowExpandController from "./row_expand_controller"
application.register("row-expand", RowExpandController)
import MetricTipController from "./metric_tip_controller"
application.register("metric-tip", MetricTipController)
import PrintController from "./print_controller"
application.register("print", PrintController)
import AiReportTreeEditorController from "./ai_report_tree_editor_controller"
application.register("ai-report-tree-editor", AiReportTreeEditorController)
import AiReportTocController from "./ai_report_toc_controller"
application.register("ai-report-toc", AiReportTocController)
